export default __webpack_public_path__ + "78e6b3daebc172c24b683a8450145418.png";